import { Directive, OnChanges, OnDestroy, SimpleChanges, TemplateRef, input, inject } from '@angular/core';
import { TeleportService } from "./teleport.service";

@Directive({
    selector: 'ng-template[teleport]',
    standalone: false
})
export class TeleportDirective implements OnChanges, OnDestroy {
  private teleport = inject(TeleportService);
  private template = inject<TemplateRef<any>>(TemplateRef);


  readonly target = input<string>(undefined, { alias: "teleport" });

  ngOnChanges(changes: SimpleChanges): void {
    const target = changes['target'];
    if (! target) { return; }

    target.previousValue && this.teleport.activate({ [target.previousValue]: null });
    target.currentValue && this.teleport.activate({ [target.currentValue]: this.template });
  }

  ngOnDestroy(): void {
    const target = this.target();
    target && this.teleport.activate({ [target]: null });
  }

}
